import ApiService from "../utils/fetch";

export const Login = async ({ username, password, recaptcha_token }) => {
    try {
        var formdata = new FormData();
        formdata.append("username", username);
        formdata.append("password", password);
        formdata.append("captcha_token", recaptcha_token);
        const response = await ApiService.post("/auth/token/", {
            body: formdata, // Add this line to include the token
        });
        return response;
    } catch (error) {
        if (error.response) {
            return error.response;
        }
        return { detail: "Network error. Please try again." };
    }
};
